import { isBrowser, isJsDom, isNode, isWebWorker } from 'browser-or-node';

export type RuntimeEngine = 'browser' | 'jsDom' | 'nodeJs' | 'webWorker';

export function getRuntimeEngine(): RuntimeEngine {
  if (isBrowser) return 'browser';
  if (isJsDom()) return 'jsDom';
  if (isNode) return 'nodeJs';
  if (isWebWorker) return 'webWorker';

  throw new Error('Runtime engine could not be identified');
}
